<div class="avatar" [title]="name" [style]="avatarStyle()">
    {{ initials }}
</div>
